// KPI estilo Conta Azul (mesmo padrão usado em FinanceiroContasPagar):
// número grande colorido, label cinza em cima, qtd embaixo. Cards inline.
// Preserva 100% o visual do monolitico — sem mudanca de comportamento.

export function KPI({ titulo, valor, sub, cor }: { titulo: string; valor: string; sub?: string; cor?: string }) {
  return (
    <div style={{ background: '#fff', padding: 14, borderRadius: 6, border: '0.5px solid #e0e0e0' }}>
      <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5 }}>{titulo}</div>
      <div style={{ fontSize: 18, fontWeight: 700, color: cor || '#020D7F', marginTop: 4 }}>{valor}</div>
      {sub && <div style={{ fontSize: 10, color: '#888', marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export function KpiCardCR({ label, valor, qtd, cor, borda, destacar }: {
  label: string; valor: number; qtd: number; cor: string; borda?: boolean; destacar?: boolean;
}) {
  const ativo = (qtd || 0) > 0;
  return (
    <div style={{
      padding: '14px 16px',
      borderLeft: borda ? '0.5px solid #e8e8ec' : 'none',
      background: destacar ? '#FAFBFF' : '#fff',
    }}>
      <div style={{ fontSize: 11, color: '#888', fontWeight: 500, marginBottom: 6 }}>
        {label}
      </div>
      <div style={{
        fontSize: 22, fontWeight: 700,
        color: ativo ? cor : '#bbb',
        lineHeight: 1.1,
      }}>
        {(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </div>
      {qtd !== undefined && (
        <div style={{ fontSize: 10, color: '#aaa', marginTop: 4 }}>
          {qtd} {qtd === 1 ? 'parcela' : 'parcelas'}
        </div>
      )}
    </div>
  );
}
